import { inject } from '@angular/core';
import { NptConfigurationService, NptMenu } from '@npt/sdk';

const menuItems: NptMenu[] = [
  { state: 'dashboard', name: 'Dashboard', icon: 'home', fontSet: 'movy-ico',  roles: [] },
  { state: 'profile', name: 'Profile', icon: 'Profile', fontSet: 'movy-ico', roles: [] },
  { state: 'registrations', name: 'Registrations', icon: 'ticket', fontSet: 'movy-ico', roles: [] },
  { state: 'history-request', name: 'Request', icon: 'Deposito', fontSet: 'movy-ico', roles: [] },
  { state: 'transits', name: 'Transits', icon: 'sbarra_up', fontSet: 'movy-ico', roles: [] },
];

export class MenuItems {
  private configService = inject(NptConfigurationService);
  private keycloakPath = { state: 'keycloak', name: 'Keycloak', icon: 'lock', roles: [] };

  getMenuitem(): NptMenu[] {
    if (this.configService.config['keycloakPath']) {
      menuItems.push(this.keycloakPath);
    }
    if (this.configService.config['hideObuRegistration'] && this.configService.config['hidePlateRegistration']) {
      const registrationsIndex = menuItems.findIndex(item => item.state === 'registrations');
      if (registrationsIndex !== -1) {
        menuItems.splice(registrationsIndex, 1);
      }
    }
    return menuItems;
  }
}
